module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/SVZI5m/media/FC-9781035818228.jpg?1708992389181",
      "alt": "This image is the cover for the book Magic Boy"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Magic Boy\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Ben and Amy Starbright stay with their grandmother while their parents go on a study field trip. The children find that Granny is not a typical granny when Granny’s friend, Cornelia Starkstare, flies past their window on a broomstick. Ben and Amy are in awe of Granny’s magical abilities and are often surprised to encounter her many secrets and her intuition in various difficult situations. She has many strange and surprising ways to sort out problems that Amy and Ben encounter. The world is very different for these children immersed in a world of magic.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Lance Cerff\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Introducing a crusty old codger with a twisted sense of humour, as displayed in the twenty-odd books written by him, some for children; also, hysterically historical tales, others spooky, a few of them gruesome but usually offbeat. He is a fit eighty-one-year-old, with a beautiful wife whom he has courted from age sixteen, four adult children, twelve grandchildren and three greatgrandchildren. Not forgetting his sister, Pam, whom he loves dearly, and her family. Then there’s Pet’s brother, Tony, his wife, Carol and their large family. When they all get together, it’s a real circus. He loves sport and has played cricket, rugby, tennis, hockey, football, squash, golf, table-tennis, is keen on fishing and car-rallied for many years. But now he’s getting too stiff to tie his shoelaces and finds pleasure in pounding the story-telling keyboard.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0